import React from 'react';
import SearchWordSaveNavbar from '../SearchWordSaveNavbar';
import SearchWordSaveInfo from '../SearchWordSaveInfo';

const SearchWordSaveWrap = (props) => {
  const {
    searchWordSave,
    setData,
    isEdit,
    onSubmit,
    checkKeyword,
    removeSearchWord,
    searchWordId,
    getRelatedSearchWordList,
    form,
  } = props;

  return (
    <div className="search-word-save-wrap">
      <SearchWordSaveNavbar
        isEdit={isEdit}
        searchWordId={searchWordId}
        searchWordSave={searchWordSave}
        onSubmit={onSubmit}
        removeSearchWord={removeSearchWord}
      />

      <SearchWordSaveInfo
        form={form}
        searchWordSave={searchWordSave}
        setData={(data) =>
          setData({
            path: ['searchWordSave', ...data.path],
            value: data.value,
          })
        }
        checkKeyword={checkKeyword}
        getRelatedSearchWordList={getRelatedSearchWordList}
        isEdit={isEdit}
      />
    </div>
  );
};

export default SearchWordSaveWrap;
